import { render, staticRenderFns } from "./VabBoxAreaBottomPanel.vue?vue&type=template&id=6df7a9f6"
import script from "./VabBoxAreaBottomPanel.vue?vue&type=script&lang=js"
export * from "./VabBoxAreaBottomPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/prod2/jobs/build/partner-assets-build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6df7a9f6')) {
      api.createRecord('6df7a9f6', component.options)
    } else {
      api.reload('6df7a9f6', component.options)
    }
    module.hot.accept("./VabBoxAreaBottomPanel.vue?vue&type=template&id=6df7a9f6", function () {
      api.rerender('6df7a9f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vab/components/VabBoxArea/components/VabBoxAreaBottomPanel.vue"
export default component.exports